module.exports = __webpack_public_path__ + "assets/img/2473.a5e1d9be.png";